import { useEffect, useState } from "react";

/** Below Tailwind's `md` breakpoint: a phone held upright. */
export const PHONE_QUERY = "(max-width: 767px)";

const matches = () => typeof window !== "undefined" && typeof window.matchMedia === "function" && window.matchMedia(PHONE_QUERY).matches;

/**
 * True on a phone-sized viewport. Read synchronously on the first render, so
 * components that start differently on a phone (a collapsed card) get it right
 * from mount; follows the viewport afterwards (rotation, a resized window).
 */
export function useIsPhone(): boolean {
  const [phone, setPhone] = useState(matches);
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") return;
    const mq = window.matchMedia(PHONE_QUERY);
    const onChange = () => setPhone(mq.matches);
    onChange();
    mq.addEventListener?.("change", onChange);
    return () => mq.removeEventListener?.("change", onChange);
  }, []);
  return phone;
}
